import { css } from 'emotion'
import { Link, Colors } from './..'

export const LoginStyle = css({
  '.login--bottom': {
    display: 'inline-block',
    marginTop: '8vh',
    ...Link,
    transition: 'all 400ms ease',
    cursor: 'pointer',
    '@media (min-height: 1024px)': {
      marginTop: '11.25rem',
    },
    'a': {
      color: Colors.mediumGrey,
      transition: 'all 400ms ease',
      '&:hover': {
        color: 'black',
      }
    }
  }
})


// WEBPACK FOOTER //
// ./src/styles/auth/login.js